import type { IconSvgObject } from './types';

const VineIcon: IconSvgObject = [
  ["path", { d: "M10.5456 21.9971C4.79298 18.153 2.71675 8.95705 3.03054 4.41356L6.571 4.55416C6.11879 10.1249 9.27675 15.6614 11.0039 17.5825C12.7476 16.549 14.3971 14.5709 14.6926 13.7533C11.0039 12.736 10.1548 9.30747 10.1783 7.76592C10.0213 5.74613 11.3232 1.89278 15.5188 2.00228C19.4949 2.10606 20.4174 6.91811 19.7548 9.18722L16.7532 8.24828C16.8701 4.89679 13.9517 5.30571 13.7127 6.91811C13.099 11.0569 17.2729 11.7171 20.9954 11.5123V14.5731H18.0526C16.1232 18.1642 12.3412 21.0546 10.5456 21.9971Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default VineIcon;
